<template>
  <div>
    <vs-card>
      <b-row>
        <b-col>
          <b-form-datepicker
            bottom
            v-model="datepickerbaslangic"
            placeholder="-"
            size="md"
            local="tr-TR"
            today-variant="danger"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
        /></b-col>
        <b-col>
          <vs-button
            @click="getCekRaporList()"
            line-origin="left"
            color="primary"
            type="gradient"
            style="border-radius: 5px"
            >Listele</vs-button
          ></b-col
        >
      </b-row>
    </vs-card>
    <vs-card style="height:500px">
      <ag-grid-vue
        style="width: 100%; height: 450px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue
    ></vs-card>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
export default {
  data() {
    return {
      rowData: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      datepickerbaslangic: "",
      weekday: 1
    };
  },
  components: {
    AgGridVue
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getCekRaporList() {
      var vm = this;
      if (vm.datepickerbaslangic == "") {
        vm.datepickerbaslangic = new Date();
      }
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        TARIH: moment(String(vm.datepickerbaslangic)).format("DD.MM.YYYY")
      };
      soap.createClient(url, function(err, client) {
        client.INT_Cek_Raporu(args, function(err, result) {
          if (result.INT_Cek_RaporuResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Cek_RaporuResult);
            var list = JSON.parse(vm.veriler.jsonData);
            vm.resimListesi = list;
          } catch (error) {}
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    }
  },
  created() {
    this.getCekRaporList();
    this.datepickerbaslangic = new Date();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  }
};
</script>
